export const GET_ALERT_DETAIL = 'GET_ALERT_DETAIL';
export const GET_ALERT_DETAIL_SUCCESS = 'GET_ALERT_DETAIL_SUCCESS';
export const GET_ALERT_DETAIL_FAIL = 'GET_ALERT_DETAIL_FAIL';

export const CLOSE_ALERT = 'CLOSE_ALERT';
export const CLOSE_ALERT_SUCCESS = 'CLOSE_ALERT_SUCCESS';
export const CLOSE_ALERT_FAIL = 'CLOSE_ALERT_FAIL';

export const GET_MODEL_EXPLAINABILITY = 'GET_MODEL_EXPLAINABILITY';
export const GET_MODEL_EXPLAINABILITY_SUCCESS =
  'GET_MODEL_EXPLAINABILITY_SUCCESS';
export const GET_MODEL_EXPLAINABILITY_FAIL = 'GET_MODEL_EXPLAINABILITY_FAIL';

export const GET_TRANSACTION = 'GET_TRANSACTION';
export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
export const GET_TRANSACTION_FAIL = 'GET_TRANSACTION_FAIL';

export const GET_HIST_ALERT_HEADER = 'GET_HIST_ALERT_HEADER';
export const GET_HIST_ALERT_HEADER_SUCCESS = 'GET_HIST_ALERT_HEADER_SUCCESS';
export const GET_HIST_ALERT_HEADER_FAIL = 'GET_HIST_ALERT_HEADER_FAIL';

export const GET_HIST_ALERT = 'GET_HIST_ALERT';
export const GET_HIST_ALERT_SUCCESS = 'GET_HIST_ALERT_SUCCESS';
export const GET_HIST_ALERT_FAIL = 'GET_HIST_ALERT_FAIL';

export const GET_RISK_INDICATORS = 'GET_RISK_INDICATORS';
export const GET_RISK_INDICATORS_SUCCESS = 'GET_RISK_INDICATORS_SUCCESS';
export const GET_RISK_INDICATORS_FAIL = 'GET_RISK_INDICATORS_FAIL';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAIL = 'GET_COUNTRIES_FAIL';

export const GET_FEATURE_CODES = 'GET_FEATURE_CODES';
export const GET_FEATURE_CODES_SUCCESS = 'GET_FEATURE_CODES_SUCCESS';
export const GET_FEATURE_CODES_FAIL = 'GET_FEATURE_CODES_FAIL';

export const GET_TRANSACTION_TYPES = 'GET_TRANSACTION_TYPES';
export const GET_TRANSACTION_TYPES_SUCCESS = 'GET_TRANSACTION_TYPES_SUCCESS';
export const GET_TRANSACTION_TYPES_FAIL = 'GET_TRANSACTION_TYPES_FAIL';

export const GET_FEATURE_CATEGORY_TYPES = 'GET_FEATURE_CATEGORY_TYPES';
export const GET_TRANSACTION_PRODUCT_MAPPING =
  'GET_TRANSACTION_PRODUCT_MAPPING';
export const GET_TRANSACTION_PRODUCT_MAPPING_SUCCESS =
  'GET_TRANSACTION_PRODUCT_MAPPING_SUCCESS';
export const GET_TRANSACTION_PRODUCT_MAPPING_FAIL =
  'GET_TRANSACTION_PRODUCT_MAPPING_FAIL';
export const GET_FEATURE_CATEGORY_SUCCESS = 'GET_FEATURE_CATEGORY_SUCCESS';
export const GET_FEATURE_CATEGORY_FAIL = 'GET_FEATURE_CATEGORY_FAIL';

export const GET_RISK_INDICATORS_GRAPH = 'GET_RISK_INDICATORS_GRAPH';
export const GET_RISK_INDICATORS_GRAPH_SUCCESS =
  'GET_RISK_INDICATORS_GRAPH_SUCCESS';
export const GET_RISK_INDICATORS_GRAPH_FAIL = 'GET_RISK_INDICATORS_GRAPH_FAIL';

export const GET_CUSTOMER_PROFILE = 'GET_CUSTOMER_PROFILE';
export const GET_CUSTOMER_PROFILE_SUCCESS = 'GET_CUSTOMER_PROFILE_SUCCESS';
export const GET_CUSTOMER_PROFILE_FAIL = 'GET_CUSTOMER_PROFILE_FAIL';

export const GET_CLUSTER_INFORMATION = 'GET_CLUSTER_INFORMATION';
export const GET_CLUSTER_INFORMATION_SUCCESS =
  'GET_CLUSTER_INFORMATION_SUCCESS';
export const GET_CLUSTER_INFORMATION_FAIL = 'GET_CLUSTER_INFORMATION_FAIL';

export const RESET_INVESTIGATION_DETAIL_DATA =
  'RESET_INVESTIGATION_DETAIL_DATA';

export const GET_LINKED_CUSTOMERS_C2C = 'GET_LINKED_CUSTOMERS_C2C';
export const GET_LINKED_CUSTOMERS_C2C_SUCCESS =
  'GET_LINKED_CUSTOMERS_C2C_SUCCESS';
export const GET_LINKED_CUSTOMERS_C2C_FAIL = 'GET_LINKED_CUSTOMERS_C2C_FAIL';

export const GET_CLUSTER_VIEW_DESCRIPTION = 'GET_CLUSTER_VIEW_DESCRIPTION';
export const GET_CLUSTER_VIEW_DESCRIPTION_SUCCESS =
  'GET_CLUSTER_VIEW_DESCRIPTION_SUCCESS';
export const GET_CLUSTER_VIEW_DESCRIPTION_FAIL =
  'GET_CLUSTER_VIEW_DESCRIPTION_FAIL';

export const UPDATE_ALERT_DETAIL = 'UPDATE_ALERT_DETAIL';

// reset investigation screen data
export function resetInvestigationData(payload) {
  return {
    type: RESET_INVESTIGATION_DETAIL_DATA,
    payload
  };
}

//alert header
export function getAlertDetail(payload) {
  return {
    type: GET_ALERT_DETAIL,
    payload
  };
}
export function getAlertDetailSuccess(payload) {
  return {
    type: GET_ALERT_DETAIL_SUCCESS,
    payload
  };
}
export function getAlertDetailFail(payload) {
  return {
    type: GET_ALERT_DETAIL_FAIL,
    payload
  };
}

//CLOSE ALERT
export function closeAlert(payload) {
  return {
    type: CLOSE_ALERT,
    payload
  };
}
export function closeAlertSuccess(payload) {
  return {
    type: CLOSE_ALERT_SUCCESS,
    payload
  };
}
export function closeAlertFail(payload) {
  return {
    type: CLOSE_ALERT_FAIL,
    payload
  };
}

export function getModelExplainability(payload) {
  return {
    type: GET_MODEL_EXPLAINABILITY,
    payload
  };
}

export function getModelExplainabilitySuccess(payload) {
  return {
    type: GET_MODEL_EXPLAINABILITY_SUCCESS,
    payload
  };
}

export function getModelExplainabilityFail(payload) {
  return {
    type: GET_MODEL_EXPLAINABILITY_FAIL,
    payload
  };
}

export function getTransactionHeaderSuccess(payload) {
  return {
    type: GET_TRANSACTION_HEADER_SUCCESS,
    payload
  };
}

export function getTransaction(payload) {
  return {
    type: GET_TRANSACTION,
    payload
  };
}

export function getTransactionSuccess(payload) {
  return {
    type: GET_TRANSACTION_SUCCESS,
    payload
  };
}

export function getTransactionFail(payload) {
  return {
    type: GET_TRANSACTION_FAIL,
    payload
  };
}

//hist alert/ transaction
export function getHistAlertHeader(payload) {
  return {
    type: GET_HIST_ALERT_HEADER,
    payload
  };
}
export function getHistAlertHeaderSuccess(payload) {
  return {
    type: GET_HIST_ALERT_HEADER_SUCCESS,
    payload
  };
}
export function getHistAlertHeaderFail(payload) {
  return {
    type: GET_HIST_ALERT_HEADER_FAIL,
    payload
  };
}
export function getHistAlert(payload) {
  return {
    type: GET_HIST_ALERT,
    payload
  };
}
export function getHistAlertSuccess(payload) {
  return {
    type: GET_HIST_ALERT_SUCCESS,
    payload
  };
}
export function getHistAlertFail(payload) {
  return {
    type: GET_HIST_ALERT_FAIL,
    payload
  };
}

// risk indicators
export function getRiskIndicators(payload) {
  return {
    type: GET_RISK_INDICATORS,
    payload
  };
}
export function getRiskIndicatorsSuccess(payload) {
  return {
    type: GET_RISK_INDICATORS_SUCCESS,
    payload
  };
}
export function getRiskIndicatorsFail(payload) {
  return {
    type: GET_RISK_INDICATORS_FAIL,
    payload
  };
}

// risk indicators graphs
export function getRiskIndicatorsGraph(payload) {
  return {
    type: GET_RISK_INDICATORS_GRAPH,
    payload
  };
}
export function getRiskIndicatorsGraphSuccess(payload) {
  return {
    type: GET_RISK_INDICATORS_GRAPH_SUCCESS,
    payload
  };
}
export function getRiskIndicatorsGraphFail(payload) {
  return {
    type: GET_RISK_INDICATORS_GRAPH_FAIL,
    payload
  };
}

// countries
export function getCountries(payload) {
  return {
    type: GET_COUNTRIES,
    payload
  };
}
export function getCountriesSuccess(payload) {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload
  };
}
export function getCountriesFail(payload) {
  return {
    type: GET_COUNTRIES_FAIL,
    payload
  };
}

// feature codes
export function getFeatureCodes(payload) {
  return {
    type: GET_FEATURE_CODES,
    payload
  };
}
export function getFeatureCodesSuccess(payload) {
  return {
    type: GET_FEATURE_CODES_SUCCESS,
    payload
  };
}
export function getFeatureCodesFail(payload) {
  return {
    type: GET_FEATURE_CODES_FAIL,
    payload
  };
}

// transaction types
export function getTransactionTypes(payload) {
  return {
    type: GET_TRANSACTION_TYPES,
    payload
  };
}
export function getTransactionTypesSuccess(payload) {
  return {
    type: GET_TRANSACTION_TYPES_SUCCESS,
    payload
  };
}
export function getTransactionTypesFail(payload) {
  return {
    type: GET_TRANSACTION_TYPES_FAIL,
    payload
  };
}

// FeatureCategory types
export function getFeatureCategoryTypes(payload) {
  return {
    type: GET_FEATURE_CATEGORY_TYPES,
    payload
  };
}
export function getFeatureCategorySuccess(payload) {
  return {
    type: GET_FEATURE_CATEGORY_SUCCESS,
    payload
  };
}
export function getFeatureCategoryFail(payload) {
  return {
    type: GET_FEATURE_CATEGORY_FAIL,
    payload
  };
}

// getClusterViewDescription types
export function getClusterViewDescription(payload) {
  return {
    type: GET_CLUSTER_VIEW_DESCRIPTION,
    payload
  };
}
export function getClusterViewDescriptionSuccess(payload) {
  return {
    type: GET_CLUSTER_VIEW_DESCRIPTION_SUCCESS,
    payload
  };
}
export function getClusterViewDescriptionFail(payload) {
  return {
    type: GET_CLUSTER_VIEW_DESCRIPTION_FAIL,
    payload
  };
}

// TransactionProductMapping types
export function getTransactionProductMapping(payload) {
  return {
    type: GET_TRANSACTION_PRODUCT_MAPPING,
    payload
  };
}
export function getTransactionProductMappingSuccess(payload) {
  return {
    type: GET_TRANSACTION_PRODUCT_MAPPING_SUCCESS,
    payload
  };
}
export function getTransactionProductMappingFail(payload) {
  return {
    type: GET_TRANSACTION_PRODUCT_MAPPING_FAIL,
    payload
  };
}

export function getLinkedCustomersC2C(payload) {
  return {
    type: GET_LINKED_CUSTOMERS_C2C,
    payload
  };
}

export function getLinkedCustomersC2CSuccess(payload) {
  return {
    type: GET_LINKED_CUSTOMERS_C2C_SUCCESS,
    payload
  };
}

export function getLinkedCustomersC2CFail(payload) {
  return {
    type: GET_LINKED_CUSTOMERS_C2C_FAIL,
    payload
  };
}

export function getCustomerProfile(payload) {
  return {
    type: GET_CUSTOMER_PROFILE,
    payload
  };
}

export function getCustomerProfileSuccess(payload) {
  return {
    type: GET_CUSTOMER_PROFILE_SUCCESS,
    payload
  };
}

export function getCustomerProfileFail(payload) {
  return {
    type: GET_CUSTOMER_PROFILE_FAIL,
    payload
  };
}

export function getClusterInformation(payload) {
  return {
    type: GET_CLUSTER_INFORMATION,
    payload
  };
}

export function getClusterInformationSuccess(payload) {
  return {
    type: GET_CLUSTER_INFORMATION_SUCCESS,
    payload
  };
}

export function getClusterInformationFail(payload) {
  return {
    type: GET_CLUSTER_INFORMATION_FAIL,
    payload
  };
}

export function updateAlertDetail(payload) {
  return {
    type: UPDATE_ALERT_DETAIL,
    payload
  };
}
